import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'
/**
 *
 *
 * @interface IForwardPage
 */
interface IForwardPage {
  /**
   * 页面 id,原生提供
   *
   * @type {string}
   * @memberof IForwardPage
   */
  pageId: string
  /**
   * 参数
   *
   * @type {string}
   * @memberof IForwardPage
   */
  param?: string
}

/**
 * 根据 pageId 及 param 跳转指定的原生界面
 *
 * @param {IBridgeOptions<IForwardPage>} {
 *   pageId = '',
 *   param = '',
 *   success,
 *   fail,
 *   complete
 * }
 */
function forwardPageSync({
  pageId = '',
  param = '',
  success,
  fail,
  complete
}: IBridgeOptions<IForwardPage>) {
  const params = formatParams({
    funType: 'forward',
    funName: 'forwardPage',
    pageId,
    param
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.error('forwardPage error: ', error)
  }
}

/**
 * 根据 pageId 及 param 跳转指定的原生界面
 * 一个异步接口，支持 Promise 化使用
 *
 * @param {IBridgeOptions<IForwardPage>} { pageId = '', param = '' }
 * @returns
 */
function forwardPage(options: IBridgeOptions<IForwardPage>) {
  const params = formatParams({
    ...{
      funType: 'forward',
      funName: 'forwardPage',
      pageId: '',
      param: ''
    },
    ...options
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { forwardPage, forwardPageSync }
